export let block_SplitButton = "KH7Bcd";
export let delete_SplitButton = "GuWIP";
export let flagUnflag_SplitButton = "Uio6Ec";
export let newMessage_SplitButton = "Smkiub";
export let report_SplitButton = "fQ9_Bb";
export let respond_SplitButton = "eDbMUb";
export let respondForward_SplitButton = "pfSmc";
export let replyCopilotMeetingToEmail_SplitButton = "PIPM0b";
export let viewGroups_SplitButton = "ajN8Ed";
export default {block_SplitButton,delete_SplitButton,flagUnflag_SplitButton,newMessage_SplitButton,report_SplitButton,respond_SplitButton,respondForward_SplitButton,replyCopilotMeetingToEmail_SplitButton,viewGroups_SplitButton};